import { DataForSearchTour, InitialSearchTour } from 'entities/tour/models'

import { HotTour, TourSearchDestination } from 'shared/api/tours/search'

export const prepareHotTour = (hotTour?: HotTour): DataForSearchTour => {
  // @ts-ignore
  if (!hotTour) return InitialSearchTour

  // @ts-ignore
  return {
    duration: hotTour?.nights,
    resorts: hotTour?.towns_to,
    country: {
      id: hotTour?.countrycode.toString(),
      state_id: hotTour?.countrycode,
      name: hotTour?.countryname,
    } as TourSearchDestination,
    flight: { startDay: hotTour?.flydate },
    is_flexible_date: false,
    is_flexible_nights: false,
  }
}
